import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4 px-2" }

import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Videos } from "../generated/graphql";
import VideoPreview from './VideoPreview.vue';


type Props = {
    language: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSelection',
  props: {
    language: null
  },
  setup(__props: any) {

const props = __props as {
    language: string;
}



const videos = ref<Videos[]>([]);

const currentVideos = computed(() => {
    return videos.value.filter(video => video.language === props.language);
});

const fetchVideos = useQuery(gql`
    query fetchVideos {
        videos {
            id
            language
            title
            description
            video {
                id
            }
            thumbnail {
                id
            }
        }
    }
`, {
    language: props.language
});

onMounted(() => {
    fetchVideos.refetch();
});

fetchVideos.onResult(res => {
    videos.value = res.data.videos as Videos[];
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentVideos), (video) => {
      return (_openBlock(), _createBlock(VideoPreview, {
        key: video.id ?? '',
        video: video,
        language: props.language
      }, null, 8, ["video", "language"]))
    }), 128))
  ]))
}
}

})